import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  { path: '/', redirect: '/addMerchant' },
  { path: '/addMerchant', name: 'addMerchant', component: () => import('../views/addMerchant.vue') },
  { path: '/business-info', name: 'BusinessInfo', component: () => import('../views/BusinessInfo.vue') },
  { path: '/service', name: 'Service', component: () => import('../views/Service.vue') },
  { path: '/contact', name: 'Contact', component: () => import('../views/Contact.vue') },
  { path: '/account', name: 'Account', component: () => import('../views/Account.vue') },
  { path: '/success', name: 'Success', component: () => import('../views/Success.vue') }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router